"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialogBrokenFilters = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var filterUtils_1 = require("./utils/filterUtils");
var ITEMS_SCROLL_LIMIT = 5;
var KpiAlertDialogBrokenFiltersSection = function (_a) {
    var filters = _a.filters, type = _a.type;
    if (!filters.length) {
        return null;
    }
    var contentClassNames = classnames_1.default("filter-section-content", {
        "more-items": filters.length > ITEMS_SCROLL_LIMIT,
    });
    return (react_1.default.createElement("div", { className: "filter-section" },
        react_1.default.createElement("div", { className: "filter-section-headline" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: type === "deleted" ? "kpiAlertDialog.removedFilters" : "kpiAlertDialog.ignoredFilters" })),
        react_1.default.createElement("div", { className: contentClassNames }, filters.map(function (filter) {
            var filterProps = filterUtils_1.getFilterLabelFilter(filter);
            return (react_1.default.createElement("div", { className: "attribute-filter-label", key: filter.title },
                react_1.default.createElement(sdk_ui_kit_1.FilterLabel, tslib_1.__assign({}, filterProps))));
        }))));
};
exports.KpiAlertDialogBrokenFilters = function (_a) {
    var brokenFilters = _a.brokenFilters;
    var _b = react_1.useMemo(function () { return partition_1.default(brokenFilters, function (filter) { return filter.brokenType === "deleted"; }); }, [brokenFilters]), deletedFilters = _b[0], ignoredFilters = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(KpiAlertDialogBrokenFiltersSection, { filters: deletedFilters, type: "deleted" }),
        react_1.default.createElement(KpiAlertDialogBrokenFiltersSection, { filters: ignoredFilters, type: "ignored" })));
};
//# sourceMappingURL=KpiAlertDialogBrokenFilters.js.map